import { get as _get } from 'lodash';
import { prettifyNumber } from 'utils/prettify';
import * as _ from 'lodash';

// const selectButtonWidth = '64px';
const itemsWidth = '65px';
const fitmentsWidth = '84px';
const fileTypeWidth = '148px';
const uploadDateWidth = '160px';
const uploadedByWidth = '130px';
const reportsWidth = '120px';
const downloadWidth = '120px';
/* eslint-disable */
const fileNameWidth = `calc(100% - ${itemsWidth} - ${fitmentsWidth} - ${fileTypeWidth} - ${uploadDateWidth} - ${uploadedByWidth} - ${reportsWidth} - ${downloadWidth})`;
/* eslint-enable */

export const columns: any = [
  {
    title: 'File Name',
    width: fileNameWidth,
    sortable: true,
    sortName: 'filename',
    sort: 'desc',
    active: false,
    col: 'filename',
    link: true,
    textEllipsis: true,
  },
  {
    title: 'Items',
    width: itemsWidth,
    sortable: false,
    active: false,
    col: 'item_count',
    type: 'number',
    textEllipsis: true,
  },
  {
    title: 'Fitments',
    width: fitmentsWidth,
    sortable: false,
    active: false,
    col: 'app_count',
    type: 'number',
    textEllipsis: true,
  },
  {
    title: 'File type',
    width: fileTypeWidth,
    sortable: false,
    active: false,
    col: 'type',
    textEllipsis: true,
  },
  {
    title: 'Upload date',
    width: uploadDateWidth,
    sortable: true,
    sortName: 'createdAt',
    sort: 'desc',
    active: true,
    col: 'created_at',
    type: 'date',
    textEllipsis: true,
  },
  {
    title: 'Uploaded by',
    width: uploadedByWidth,
    sortable: true,
    sortName: 'uploadedBy',
    sort: 'desc',
    active: false,
    col: 'uploaded_by',
    textEllipsis: true,
  },
  {
    title: 'Reports',
    width: reportsWidth,
    sortable: false,
    active: false,
    col: 'report',
    sortName: 'report',
    sort: 'desc',
  },
  {
    title: 'Download',
    width: downloadWidth,
    sortable: false,
    active: false,
    col: 'download',
    icon: 'download-icon',
    align: 'right',
    textEllipsis: true,
  },
];
